 
import React,{useRef, useState} from "react";

import{Modal,Button} from 'react-bootstrap';
import { Link } from "react-router-dom";
import {RiSettings3Line} from 'react-icons/ri'

import { FaHeadphones } from "react-icons/fa";
import { BsGlobe } from "react-icons/bs";




function CreateAudioPost(onFileSelect){
    const [show, setShow]=useState(false);
    const [postLabel,setPostLabel]=useState(false)
    const [inputValue,setInputValue]=useState("")
    const handleClose =()=>setShow(false);
    const handleShow =()=>setShow(true);
    // const [newPost,setNewPost]=useState({
    //     title:"",
    //     description:""
    // })
    
const handleInputChange=(event)=>{
    setInputValue(event.target.value)
}

const fileInputRef =useRef(null);

function handleFileSelect(event) {
  const file=event.targer.files[0]
  onFileSelect(file)
}

function handleImageClick() {
  fileInputRef.current.click()
}

// const handleTogglePostLabel=(event)=>{
//     setPostLabel((current)=>!current)
// }

return(
    <>
<p className="border-0" variant="white"  onClick={handleShow}>
<Link style={{color:"rgb(124, 92, 255)"}}>
    <h1> <FaHeadphones/> </h1>
  </Link>
  Audio
</p>

<Modal className="modal"  show={show} onHide={handleClose}>
<Modal.Header  className="d-flex justify-content-between"  >

<Modal.Title>
<p className="user fw-bold fs-6">centeee</p> 

</Modal.Title>

<p className="fw-bolder fs-4"> <RiSettings3Line/></p>

</Modal.Header>

<Modal.Body>
<div className="line "></div>
<div >
<label  className="fs-5 row  justify-content-center text-center p-5" style={{background:"whitesmoke"}}   htmlFor="file-input" onClick={handleImageClick}>
<div className=" col fs-1 border-end border-light"> <span>+</span><FaHeadphones/> </div>
<div className=" col fs-1"><span>+</span>  <BsGlobe/>  </div>


</label>
<input type="file" 
onChange={handleFileSelect}
ref={fileInputRef}
 hidden
/>



</div>
<div className="line "></div>
    <textarea
    className='form-control border-0 p-5 border-white'
      type="text "
    onChange={handleInputChange}
    value={inputValue}
    placeholder="Go ahead and write anything"
     />
     <br />

<input type="text" className="form-control border-0 border-white"
    placeholder="#tags"
 />
     
</Modal.Body>

<Modal.Footer className="d-flex justify-content-between">

<div className="  ">
<Button variant="light" className=" text-start rounded-pill text-dark border-1  ps-4 pe-4 " onClick={handleClose} style={{background:"rgb(134, 132, 132)"}}>
Close

</Button>
</div>

<div className="dropdown">
  <button className="bg-white  rounded-pill btn btn-secondary dropdown-toggle text-decoration-none p-2 text-black fw-bolder" type="button" data-bs-toggle="dropdown" aria-expanded="false"
  style={{border:"3px solid gray"}}

  >
    Everyone
  </button>

   <ul className="dropdown-menu">
   <li className="fw-bolder">Community labels</li>
    <li><Link className="dropdown-item">Mature</Link></li>
    <li><Link className="dropdown-item" > Drug and alcohol addication</Link></li>
    <li><Link className="dropdown-item" >Violence</Link></li>
    
  </ul>


</div>


</Modal.Footer>


</Modal>




    </>
)

}
export default CreateAudioPost